module.exports = __webpack_public_path__ + "img/carshina21_24.1e68f72a.jpg";